import {BaseTagData, ChangeEventData, ClickEventData} from '@yaireo/tagify';
import {MixedTags, TagifyMixedTagsReactProps} from '@yaireo/tagify/dist/react.tagify';
import {isString} from 'lodash';
import React, {Component} from 'react';

import {stripZeroWidthSpaces} from './tagifyHelpers';

export class TagifyWrapper<T extends BaseTagData> extends Component<TagifyMixedTagsReactProps<T>> {
  private currentValue: string | undefined;

  componentDidUpdate() {
    this.currentValue = normalizeValue(this.props.value);
  }

  private onChange = (event: CustomEvent<ChangeEventData<T>>) => {
    // Store value from tagify so we don't re-render unnecessarily.
    this.currentValue = normalizeValue(event.detail.value);

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  private onClick = (event: CustomEvent<ClickEventData<T>>) => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  // Skip re-renders caused by updates triggered by tagify.
  // This prevents a lot of selection issues.
  shouldComponentUpdate(nextProps: TagifyMixedTagsReactProps<T>) {
    const nextValue = normalizeValue(nextProps.value);

    return (
      this.currentValue !== nextValue ||
      this.props.className !== nextProps.className ||
      this.props.readOnly !== nextProps.readOnly ||
      this.props.placeholder !== nextProps.placeholder
    );
  }

  render() {
    return <MixedTags {...this.props} onChange={this.onChange} onClick={this.onClick} />;
  }
}

function normalizeValue<T>(value: string | string[] | T[] | undefined) {
  return isString(value) ? stripZeroWidthSpaces(value.trim()) : '';
}
